export default function clear() {
  this.text = '';
  this.update();
}